import type { FieldError } from 'react-hook-form'

/**
 * Get array of field errors when criteriaMode is 'all'
 */
export const getFieldErrors = (
  fieldError: FieldError | undefined,
): string[] | undefined => {
  return fieldError?.types
    ? Object.entries(fieldError.types).flatMap(([, value]) => [
        ...(!value ? [] : Array.isArray(value) ? value : [value]),
      ])
    : undefined
}
